// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "status", "controls"]

  initialize() {
    this.displayControls()
  }

  connect() {
  }

  select() {
    this.displayControls()
  }

  displayControls() {

    if (this.statusTarget.value == "closed") {
      this.controlsTarget.style.visibility="visible"
    }
    else {
      this.controlsTarget.style.visibility="collapse"
    }
  }
}
